import { FC, ReactNode } from "react";
import { SocialMedia } from "../../../types/site";
import TwitterIcon from "../../icons/twitter-icon";
import FacebookRoundIcon from "../../icons/facebook-round-icon";
import YoutubeIcon from "../../icons/youtube-icon";
import IgIcon from "../../icons/ig-icon";

interface ISocialMediaItem {
  media: SocialMedia;
  className?: string;
}

function getIconForSocial(social: string): ReactNode | null {
  switch (social) {
    case "facebook":
      return <FacebookRoundIcon />;
    case "youtube":
      return <YoutubeIcon />;
    case "instagram":
      return <IgIcon />;
    case "twitter":
      return <TwitterIcon />;
    default:
      return null;
  }
}

const SocialMediaItem: FC<ISocialMediaItem> = ({ media, className }) => {
  const socialIcon = getIconForSocial(media.type);
  return socialIcon ? (
    <a
      title={media.type}
      href={media.url}
      className={className}
      key={media.type}
      target="_blank"
      rel="noopener nofollow noreferrer"
    >
      {socialIcon}
    </a>
  ) : null;
};

export default SocialMediaItem;
